import { Tooltip } from 'antd';

import Icon from '@ant-design/icons';

import styled from 'styled-components';
import { ReactComponent as SSCIcon } from '../../assets/img/results/ssc.svg';
import { ReactComponent as LddIcon } from '../../assets/img/results/ldd.svg';
import { ReactComponent as RipIcon } from '../../assets/img/results/rip.svg';
import { ReactComponent as AcIcon } from '../../assets/img/results/ac.svg';
import { ReactComponent as BhtIcon } from '../../assets/img/results/bht.svg';
import { ReactComponent as SripIcon } from '../../assets/img/results/gf.svg';

const StyledIcon = styled(Icon)`
    font-size: 29px;
    margin-top: -9px;
    &.anticon {
        transform: translateY(5px);

        margin-left: -5px;
        margin-right: -5px;
    }
`;

const getIcon = (id) => {
    switch (id) {
        case 'ldd':
            return LddIcon;
        case 'rip':
            return RipIcon;
        case 'ac':
            return AcIcon;
        case 'bht':
            return BhtIcon;
        case 'ssc':
            return SSCIcon;
        case 'srip':
            return SripIcon;
        default:
            return null;
    }
};
const ChartLabel = ({ id, title }) => {
    const icon = getIcon(id);
    if (!icon) return title;

    return (
        <Tooltip title={title}>
            {<StyledIcon component={getIcon(id)} />}
        </Tooltip>
    );
};

export default ChartLabel;
